'use client';

import Image from 'next/image';
import { useLocale } from 'next-intl';
import getMainCategories, {
  Category,
  getCategoryBySlug,
} from '@/src/utils/getMainCategories';
import Link from 'next-intl/link';
import { usePathname } from 'next-intl/client';
import { useLocaleRoutes } from '@/src/utils/useLocaleRoutes';
import '@components/SubcategoriesNavbar.css';
import { useGetLocalizedName } from '../utils/internationalization/getLocalizedName';

export default function CategoriesNavbar({
  categorySlug = null,
  onClick = () => {},
}: {
  categorySlug: string | null;
  onClick: () => void;
}) {
  const pathname = usePathname();
  const path = useLocaleRoutes();
  const getLocalizedName = useGetLocalizedName();

  categorySlug = null;
  const firstPath = pathname.split('/')[1];
  getMainCategories().map((mainCat: Category) => {
    if (firstPath === path(mainCat.slug)) {
      categorySlug = mainCat.slug;
    }
  });

  return (
    <div className='order-5'>
      <div className='relative border-b border-[#4B4B4B]'>
        <nav className='order-3 mx-auto mb-2 mt-1 w-full max-w-[90rem] flex-grow px-3 lg:my-0 lg:px-10'>
          <ul className='flex flex-col flex-wrap gap-6 gap-y-2 font-roboto-condensed font-bold uppercase lg:flex-row'>
            {getMainCategories().map((mainCat: Category) => {
              if (!mainCat.slug) return null;
              const cat = getCategoryBySlug(mainCat.slug);
              return (
                <li key={cat.id}>
                  <Link
                    href={`/${path(`${mainCat.slug}`)}`}
                    onClick={onClick}
                    prefetch={true}
                    className={`mt-[2px] inline-flex items-center gap-1 border-b-2 py-1 text-brand hover:border-white hover:text-white ${
                      firstPath === path(mainCat.slug)
                        ? 'border-brand text-white'
                        : 'border-transparent'
                    }`}
                  >
                    <span className='flex min-w-[2em] justify-center'>
                      <Image
                        src={cat.icon || `/images/${mainCat.slug}.svg`}
                        alt=''
                        width={0}
                        height={0}
                        style={{ width: 'auto', height: '1em' }}
                      />
                    </span>
                    {getLocalizedName(cat) || mainCat.slug}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </div>
  );
}
